import React from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap';

import './market_styles/marketbuttons.css';

export default function MarketButtons() {
  return (
    <>
      <Container className='mt-5 mb-5'>
        <Row>
          <Col lg={6} className='mx-auto mark_btns_col'>
            <Button className='col-3'>FAVOURITE</Button>
            <Button className='col-3'>ZONE</Button>
            <Button className='col-3'>SPOT</Button>
            <Button className='col-3'>FUTURES</Button>
          </Col>
        </Row>
      </Container>
    </>
  )
}
